import { useCallback, useContext, useEffect } from 'react';

import { message, Modal, Typography } from 'antd';

import { PreliquidationStepButtons, Summary } from '../../../../shared/components';
import { PaymentMethodSection } from '../PaymentMethodSection';
import { TableMethodsPaymentAdded } from '../TableMethodsPaymentAdded';

import { GenericDataFormContext } from '../../../../shared/contexts/GenericDataForm';
import { StepOneFormContext } from '../../../StepOne/contexts/StepOneForm';
import { StepThreeFormContext } from '../../contexts/StepThreeForm';
import { WizardDataFormContext } from '../../../../Wizard/contexts/WizardDataForm';

import { PreLiquidationStep } from '../../../../shared/interfaces';

import { formattedPrice } from '../../../../../../../shared/utils';
import { PaymentMethodsAdded } from '../../interfaces';
import { useLocation } from 'react-router-dom';
import { useNavBlocker } from '../../../../shared/components/NavigationAlertModal';
import { ColSize, RowSize } from '../../../../../../../shared/components';
import {
  hasPaymentsMissingRequiredFile,
  PAYMENT_FILE_REQUIRED_MESSAGE,
} from '../../../../shared/utils/payment-file-validation';


export const FormPaymentMethods = () => {
  const { setCurrentStep, loadPreliquidationState } = useContext(GenericDataFormContext);
  const { setCanShowConfirmIssue } = useContext(WizardDataFormContext);
  const { setPaymentMethodsDataTable, paymentMethodsDataTable, calculatedTotals, postSendPreliquidation, proccessPayments, paymentsToLoad, paymentsList, filesToSend} = useContext(StepThreeFormContext);
  const { totalAmountPaid, totalRemainder } = calculatedTotals
  const { hasChanges } = useContext(StepThreeFormContext);

  const { totalSelected } = useContext(StepOneFormContext);
  const location = useLocation();

  const isPreliquidacion = location.pathname.startsWith(
    "/cobranzas/preliquidacion"
  );
  const { showPrompt, confirmNavigation, cancelNavigation } = useNavBlocker(
    isPreliquidacion,
    hasChanges
  );

  const handlerOnClick = useCallback(async () => {
    try {
      if(!paymentMethodsDataTable.length) {
        message.error('Para confirmar el pago primero debe agregar por lo menos una forma de pago.');
        return;
      };

      const totalMountPaymentMethods= paymentMethodsDataTable.reduce((acc: number, item: PaymentMethodsAdded) => Number(acc) + Number(item.exactAmount), 0);
      
      if (Math.round(totalMountPaymentMethods * 100) !== Math.round(totalSelected * 100)) {
        message.error('La suma de los montos no es igual al total.');
        return;
      }

      if (hasPaymentsMissingRequiredFile(paymentsToLoad, paymentsList)) {
        message.error(PAYMENT_FILE_REQUIRED_MESSAGE);
        return;
      }

      const paymentsProcesedResponse = await proccessPayments();
      if (!paymentsProcesedResponse) return;
      
      try {
        await postSendPreliquidation();
        setCanShowConfirmIssue(true);
      } catch (error) {
        console.error('Error al enviar preliquidación:', error);
        // Aquí puedes mostrar un mensaje de error al usuario
      }
    } catch (error) {}
  }, [
    paymentMethodsDataTable, 
    setCanShowConfirmIssue, 
    totalSelected, 
    postSendPreliquidation,
    proccessPayments,
    paymentsToLoad,
    paymentsList,
    filesToSend
  ]);

  const handlerBackButtonOnClick = useCallback(() => {
    try {
      setPaymentMethodsDataTable([])
      setCurrentStep(PreLiquidationStep.TWO);
    } catch (error) {}
  }, [setCurrentStep, setPaymentMethodsDataTable]);

  return (
    <>
    {/* Modal global de confirmación de navegación */}
    <Modal
        title={"Hay cambios sin guardar"}
        centered
        open={showPrompt}
        closeIcon={false}
        onOk={confirmNavigation}
        onCancel={cancelNavigation}
      >
        <>
          <RowSize
            rowProps={{ gutter: [0, 0], justify: "end", align: "middle" }}
          >
            <ColSize size={100}>
              <Typography.Text>
                ⚠️ Tenés cambios sin guardar. Si salís ahora, se perderán.
              </Typography.Text>
            </ColSize>
          </RowSize>
        </>
      </Modal>
      <PaymentMethodSection />

      <TableMethodsPaymentAdded />

      <Summary data={[{ label: "Total a Pagar", value: <b>{`$ ${formattedPrice(totalSelected.toString())}`}</b> }, { label: "Suma de Valores", value: <b>{`$ ${formattedPrice(totalAmountPaid.toString())}`}</b> }, { label: "Saldo a Cubrir", value: <b>{`$ ${formattedPrice(totalRemainder.toString())}`}</b> }]}/>

      <PreliquidationStepButtons
        label='Confirmar el pago'
        onClick={handlerOnClick}
        onPressBackButton={handlerBackButtonOnClick}
      />
    </>
  );
};
